import gql from 'graphql-tag';

const GET_CONTRACT_REMAINING_UNITS = gql`
  query getContractRemainingUnits($input: [ContractIdentifierInput!]!) {
    getContractRemainingUnits(input: $input) {
      contract
      remainingUnits
    }
  }
`;

const GET_UNPROVISIONED_INCLUDED_ITEMS_BY_CHARGE = gql`
  query getUnProvisionedIncludedItems($input: ClientIdentifierInput!) {
    getUnProvisionedIncludedItems(input: $input) {
      name
      itemId
    }
  }
`;

const GET_CONTRACT_INCLUDED_ITEMS_BY_CHARGE = gql`
  query getContractIncludedItemsByCharge(
    $input: GetContractItemsByChargeInput!
  ) {
    getContractIncludedItemsByCharge(input: $input) {
      contractId
      serviceCatalogItem {
        name
        itemId
      }
      provisionRuleItem {
        provisionRule {
          name
          provisionRuleId
        }
        serviceCatalogItem {
          name
          itemId
        }
      }
    }
  }
`;

const GET_CONTRACT_APPLICATION_CONDITION = gql`
  query getContractApplicationConditionMeta {
    getContractApplicationConditionMeta
  }
`;

const FETCH_CLIENT_CONTRACT_TYPE_BY_ID = gql`
  query fetchClientContract($input: ContractIdentifierInput!) {
    fetchClientContract(input: $input) {
      contract {
        contractId
        contractType
      }
    }
  }
`;

const FETCH_CLIENT_CONTRACT = gql`
  query fetchClientContract($input: ContractIdentifierInput!) {
    fetchClientContract(input: $input) {
      client {
        accountId
      }
      endDate
      startDate
      canEditEndDate
      remindDuration {
        unit
        quantity
      }
      contractStatus
      contract {
        contractId
        name
        description
        contractType
        updatedTime
        billableContract {
          cumulatedQuantity
          billableSiteType
          contractId
          chargeItem {
            itemId
            name
            description
            itemType
            offerAsWorklogItem
            status
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            serviceTypeItem {
              itemId
              offeringType
              # hourlyServiceTypeItem {
              #   itemId
              #   roundUpValue
              # }
              redeemableServiceBundle {
                itemId
                applicableType
                applicableHours
                redeemableQuantity
              }
            }
          }
          frequencyType
          quantityCalculationType
          sellingPriceCalculationType
          sellingPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          sellingPriceOverridden
          discountRate
          generateInvoice
          paymentTerm {
            paymentTermId
            paymentTermName
          }
          changes {
            changeId
            prorated
            proratedAmount
            effectiveDate
            quantity
            quantityChangeOperation
            generateInvoice
          }
          project {
            projectId
            site {
              id
              name
            }
          }
          provisionRule {
            provisionRuleId
            name
            ruleEntityType
            # ruleCondition
            # items {
            #   itemId
            #   name
            # }
            # parentRule {
            #   provisionRuleId
            # }
            siteQuantities {
              site {
                id
              }
              quantity
            }
            defaultRule
          }
          includedItemList {
            contractId
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            provisionRule {
              provisionRuleId
              name
              ruleEntityType
              # ruleCondition
              # items {
              #   itemId
              #   name
              # }
              # parentRule {
              #   provisionRuleId
              # }
              siteQuantities {
                site {
                  id
                }
                quantity
              }
              defaultRule
            }
            serviceCatalogItem {
              itemId
              name
              description
              # category {
              #   categoryId
              #   name
              # }
              itemType
              # offerAsWorklogItem
              # status
              # taxable
              # salesTax {
              #   taxId
              # }
              sellingPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              costPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              serviceTypeItem {
                itemId
                offeringType
                redeemableServiceBundle {
                  itemId
                  redeemableQuantity
                }
                # bundledItems {
                #   name
                #   itemId
                #   itemType
                #   sellingPrice {
                #     model
                #     details {
                #       value
                #       afterHoursValue
                #     }
                #   }
                #   costPrice {
                #     model
                #     details {
                #       value
                #       afterHoursValue
                #     }
                #   }
                # }
                # hourlyServiceTypeItem {
                #   itemId
                #   roundUpValue
                #   defaultItem
                # }
              }
            }
          }
          # includedItems {
          #   itemId
          #   name
          #   description
          #   category {
          #     categoryId
          #     name
          #   }
          #   itemType
          #   offerAsWorklogItem
          #   status
          #   taxable
          #   salesTax {
          #     taxId
          #   }
          #   sellingPrice {
          #     model
          #     details {
          #       value
          #       afterHoursValue
          #     }
          #   }
          #   costPrice {
          #     model
          #     details {
          #       value
          #       afterHoursValue
          #     }
          #   }
          #   serviceTypeItem {
          #     itemId
          #     offeringType
          #     bundledItems {
          #       name
          #       itemId
          #       itemType
          #       sellingPrice {
          #         model
          #         details {
          #           value
          #           afterHoursValue
          #         }
          #       }
          #       costPrice {
          #         model
          #         details {
          #           value
          #           afterHoursValue
          #         }
          #       }
          #     }
          #     hourlyServiceTypeItem {
          #       itemId
          #       roundUpValue
          #       defaultItem
          #     }
          #     redeemableServiceBundle {
          #       itemId
          #       applicableType
          #       applicableHours
          #       redeemableQuantity
          #     }
          #   }
          # }
          sites {
            id
            name
          }
          recurringContract {
            contractId
            recurringMode
            frequencyDurationUnit
            frequencyInterval
            billingOffset
            nextBillDate
          }
          redeemableContract {
            contractId
            applicableType
            applicableHours
            carryForwardRemainingQuantity
            reminderThreshold
          }
          perpetualContract {
            contractId
            autoRenew
          }
          blockItemsInfo {
            blockItemId
            balance
          }
          usageContract {
            contractId
            integrationSource
          }
        }
        contractApplication {
          contractId
          contractOrder
          applicationRuleCondition
          contractSLA {
            id
            sla {
              id
              name
            }
            slaOrder
          }
          autoApproveItems {
            itemId
            name
            description
          }
          blacklistedItems {
            itemId
            name
            description
          }
          overrides {
            overrideId
            overrideCategory
            conditionalPricing {
              overrideId
              name
              ticketRuleCondition
            }
            overrideItems {
              overrideItemId
              serviceCatalogItem {
                itemId
                name
                description
                itemType
                offerAsWorklogItem
                status
                serviceTypeItem {
                  itemId
                  offeringType
                }
                sellingPrice {
                  model
                  details {
                    value
                    afterHoursValue
                  }
                }
                # costPrice {
                #   model
                #   details {
                #     value
                #     afterHoursValue
                #   }
                # }
              }
              overrideValue {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              overrideType
              overrideByMetric
            }
          }
        }
      }
    }
  }
`;

const FETCH_CLIENT_CONTRACTS_LIST = gql`
  query fetchClientContractList($listInfo: ListInfoInput) {
    fetchClientContractList(listInfo: $listInfo) {
      clientContracts {
        contractStatus
        startDate
        endDate
        remindDuration {
          unit
          quantity
        }
        client {
          accountId
          name
        }
        contract {
          contractId
          name
          description
          contractType
          updatedTime
          billableContract {
            cumulatedQuantity
            billableSiteType
            contractId
            chargeItem {
              itemId
              name
              itemType
              description
              sellingPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              serviceTypeItem {
                itemId
                offeringType
                hourlyServiceTypeItem {
                  itemId
                  roundUpValue
                  defaultItem
                }
                redeemableServiceBundle {
                  itemId
                  applicableType
                  applicableHours
                  redeemableQuantity
                }
              }
            }
            frequencyType
            quantityCalculationType
            sellingPriceCalculationType
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            sellingPriceOverridden
            discountRate
            generateInvoice
            paymentTerm {
              paymentTermId
              paymentTermName
            }
            provisionRule {
              provisionRuleId
              name
              ruleEntityType
              ruleCondition
              items {
                itemId
                name
              }
              parentRule {
                provisionRuleId
              }
              # siteQuantities {
              #   site {
              #     id
              #   }
              #   quantity
              # }
              defaultRule
            }
            changes {
              changeId
              effectiveDate
              endDate
              quantity
              quantityChangeOperation
              generateInvoice
              prorated
            }
            project {
              projectId
            }
            includedItems {
              itemId
              name
            }
            sites {
              id
              name
            }
            recurringContract {
              contractId
              recurringMode
              frequencyDurationUnit
              frequencyInterval
              billingOffset
              nextBillDate
            }
            redeemableContract {
              contractId
              applicableType
              applicableHours
              carryForwardRemainingQuantity
              reminderThreshold
            }
            perpetualContract {
              contractId
              autoRenew
            }
            blockItemsInfo {
              blockItemId
              balance
            }
            usageContract {
              contractId
              integrationSource
            }
          }
          contractApplication {
            contractId
            contractOrder
            applicationRuleCondition
            contractSLA {
              id
              sla {
                id
                name
              }
              slaOrder
            }
            autoApproveItems {
              itemId
              name
              description
            }
            blacklistedItems {
              itemId
              name
              description
            }
            overrides {
              overrideId
              overrideCategory
              conditionalPricing {
                overrideId
                name
                ticketRuleCondition
              }
              overrideItems {
                overrideItemId
                serviceCatalogItem {
                  itemId
                  name
                }
                overrideValue {
                  model
                  details {
                    value
                    afterHoursValue
                  }
                }
                overrideType
                overrideByMetric
              }
            }
          }
        }
      }
      listInfo {
        page
        pageSize
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const FETCH_CLIENT_CONTRACTS_LIST_FOR_SUBSCRIPTION_REMINDER = gql`
  query fetchClientContractList($listInfo: ListInfoInput) {
    fetchClientContractList(listInfo: $listInfo) {
      clientContracts {
        contractStatus
        startDate
        endDate
        remindDuration {
          unit
          quantity
        }
        client {
          accountId
          name
        }
        contract {
          contractId
          name
          contractType
        }
      }
    }
  }
`;

const FETCH_CLIENT_CONTRACTS_LIST_FOR_TICKET = gql`
  query fetchClientContractList($listInfo: ListInfoInput) {
    fetchClientContractList(listInfo: $listInfo) {
      clientContracts {
        client {
          accountId
          name
        }
        contract {
          contractId
          name
          contractType
          billableContract {
            contractId
            chargeItem {
              name
              itemId
            }
          }
        }
      }
    }
  }
`;

const FETCH_ALL_CLIENT_CONTRACTS_LIST = gql`
  query fetchClientContractList($listInfo: ListInfoInput) {
    fetchClientContractList(listInfo: $listInfo) {
      clientContracts {
        contractId
        contractStatus
        startDate
        endDate
        remindDuration {
          unit
          quantity
        }
        client {
          accountId
          name
        }
        contract {
          contractId
          name
          description
          contractType
          billableContract {
            cumulatedQuantity
            billableSiteType
            contractId
            chargeItem {
              itemId
              name
              itemType
              description
              sellingPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              serviceTypeItem {
                itemId
                offeringType
                hourlyServiceTypeItem {
                  itemId
                  roundUpValue
                  defaultItem
                }
                redeemableServiceBundle {
                  itemId
                  applicableType
                  applicableHours
                  redeemableQuantity
                }
              }
            }
            frequencyType
            quantityCalculationType
            sellingPriceCalculationType
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            changes {
              changeId
              effectiveDate
              endDate
              quantity
              quantityChangeOperation
              generateInvoice
              prorated
            }
            discountRate
            generateInvoice
            sellingPriceOverridden
            provisionRule {
              provisionRuleId
              name
              ruleEntityType
              ruleCondition
              items {
                itemId
                name
              }
              parentRule {
                provisionRuleId
              }
              # siteQuantities {
              #   site {
              #     id
              #   }
              #   quantity
              # }
              defaultRule
            }
            sites {
              id
              name
            }
            recurringContract {
              contractId
              recurringMode
              frequencyDurationUnit
              frequencyInterval
              billingOffset
              nextBillDate
            }
            blockItemsInfo {
              blockItemId
              balance
            }
            usageContract {
              contractId
              integrationSource
            }
          }
          contractApplication {
            contractId
            contractOrder
          }
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const GET_CONTRACT_NEXT_BILL_DATE = gql`
  query getContractNextBillDate($input: GetContractNextBillDateInput!) {
    getContractNextBillDate(input: $input)
  }
`;

const GET_CONTRACT_PRORATED_AMOUNT = gql`
  query getContractProRatedAmount($input: GetContractProRatedAmountInput!) {
    getContractProRatedAmount(input: $input)
  }
`;

export {
  FETCH_CLIENT_CONTRACT_TYPE_BY_ID,
  FETCH_CLIENT_CONTRACT,
  FETCH_CLIENT_CONTRACTS_LIST,
  FETCH_ALL_CLIENT_CONTRACTS_LIST,
  GET_CONTRACT_APPLICATION_CONDITION,
  GET_CONTRACT_REMAINING_UNITS,
  GET_UNPROVISIONED_INCLUDED_ITEMS_BY_CHARGE,
  GET_CONTRACT_INCLUDED_ITEMS_BY_CHARGE,
  GET_CONTRACT_NEXT_BILL_DATE,
  GET_CONTRACT_PRORATED_AMOUNT,
  FETCH_CLIENT_CONTRACTS_LIST_FOR_TICKET,
  FETCH_CLIENT_CONTRACTS_LIST_FOR_SUBSCRIPTION_REMINDER
};
